<template>
  <div>
    <v-row v-if="requests.length">
      <v-col cols="12">
        <h2 class="text-h5 mb-4">
          {{ $t("admin.user.requests") }}
        </h2>

        <OfferForm v-for="booking in requests" :key="booking.id" :booking="booking" :userId="user.id" />
      </v-col>
    </v-row>

    <v-row v-if="offers.length">
      <v-col cols="12">
        <h2 class="text-h5 mb-4">
          {{ $t("admin.user.offers") }}
        </h2>

        <v-card v-for="booking in offers" :key="booking.id" class="mb-2">
          <v-card-title>
            {{ booking.year }}

            <v-spacer></v-spacer>

            <v-btn v-if="booking.offer" :href="booking.offer.url" target="_blank" color="secondary" icon>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-card-title>

          <BookingPriceTable :booking="booking" />
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="accepted.length">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("admin.user.accepted") }}
          </v-card-title>

          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th width="20%">{{ $t("user.bookings.auditPeriod.title") }}</th>
                  <th width="20%">{{ $t("user.bookings.funds.title") }}</th>
                  <th width="20%">{{ $t("user.bookings.grossTotal.title") }}</th>
                  <th width="20%">{{ $t("user.bookings.acceptedAt.title") }}</th>
                  <th width="1%">{{ $t("user.bookings.invoice.title") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="booking in accepted" :key="booking.id">
                  <td>{{ booking.year }}</td>
                  <td>{{ booking.funds.length }}</td>
                  <td>{{ formatCurrency(booking.grossTotal) }}</td>
                  <td>
                    {{
                      new Date(booking.acceptedAt).toLocaleString(undefined, {
                        timeZone: "CET",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                    }}
                  </td>
                  <td>
                    <v-btn v-if="booking.invoice" :href="booking.invoice.url" target="_blank" color="secondary" icon>
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="rejected.length">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("admin.user.rejected") }}
          </v-card-title>

          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th width="50%">{{ $t("user.bookings.auditPeriod.title") }}</th>
                  <th width="25%">{{ $t("user.bookings.funds.title") }}</th>
                  <th width="25%">{{ $t("user.bookings.rejectedAt.title") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="booking in rejected" :key="booking.id">
                  <td>{{ booking.year }}</td>
                  <td>{{ booking.funds.length }}</td>
                  <td>
                    {{
                      new Date(booking.rejectedAt).toLocaleString(undefined, {
                        timeZone: "CET",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { filter, propEq } from "ramda";
import OfferForm from "./OfferForm.vue";
import BookingPriceTable from "@/components/Booking/BookingPriceTable.vue";

export default {
  components: {
    OfferForm,
    BookingPriceTable,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    requests() {
      return filter(propEq("state", "REQUESTED"), this.user.bookings);
    },
    offers() {
      return filter(propEq("state", "OFFERED"), this.user.bookings);
    },
    accepted() {
      return filter(propEq("state", "ACCEPTED"), this.user.bookings);
    },
    rejected() {
      return filter(propEq("state", "REJECTED"), this.user.bookings);
    },
  },
  methods: {
    formatCurrency: new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format,
  },
};
</script>
